import Table, { TableAvatarText, TableBadge, TableLink, TableTextStack } from './Table';

export default Table;
export { TableAvatarText, TableBadge, TableLink, TableTextStack };
